"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const tryToGetCache = async ({
  runtimeCacheKey,
  runtimeCache,
  getCacheFromStorage
}) => {
  const cache = runtimeCache.get(runtimeCacheKey);

  if (cache) {
    return new Map(cache);
  }

  if (!getCacheFromStorage) {
    return new Map();
  }

  try {
    let cacheFromStorage = await getCacheFromStorage();

    if (typeof cacheFromStorage === 'string') {
      const fixedCache = JSON.parse(cacheFromStorage);
      cacheFromStorage = fixedCache;
    }

    return new Map(cacheFromStorage);
  } catch (e) {
    throw new Error('failed to load cache from storage. ' + e);
  }
};

var _default = tryToGetCache;
exports.default = _default;